var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_explorer",
    d: "M10,9.12a.88.88,0,1,0,.88.88A.877.877,0,0,0,10,9.12ZM10,2a8,8,0,1,0,8,8A8,8,0,0,0,10,2Zm1.752,9.752L5.2,14.8,8.248,8.248,14.8,5.2Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExplorer);
export default __webpack_public_path__ + "static/media/ic_explorer.599cd3e423a7d10ef6c14ba965a395f1.svg";
export { ForwardRef as ReactComponent };